import { useEffect, useState } from 'react';
import { gql } from '@apollo/client';
import {
  ApplicationPickerItem,
  applicationPickerItems,
} from '../components/AppMenu/applicationPickerItems';
import useClient from './useClient';
import { listUserAccessesByUserId } from '#/tis/graphql';
import { APP_IDS } from '../constants/applications';

const useApplicationPickerItems = (): ApplicationPickerItem[] => {
  // TODO: Replace with TIS Cognito user ID once TIS integration is fully configured.
  // For now using hardcoded ID for testing against our own GraphQL endpoint.
  const userId = 'c7c768de-195e-4b53-8243-198652e3d62b';
  const [items, setItems] = useState<ApplicationPickerItem[]>([]);
  const client = useClient();

  useEffect(() => {
    client &&
      client
        .query({
          query: gql(listUserAccessesByUserId),
          variables: { userId },
        })
        .then(({ data }) => {
          const accessMap = new Map<string, string>(
            data.listUserAccessesByUserId.items.map((item: any) => [item.app.id, item.app.name]),
          );
          const result: ApplicationPickerItem[] = applicationPickerItems
            .filter((item) => item.alwaysVisible || accessMap.has(item.id))
            .map((item) => ({
              ...item,
              name: accessMap.get(item.id) ?? item.name,
            }));

          const hasCommandCenter = result.some((item) => item.id === APP_IDS.COMMAND_CENTER);
          if (!hasCommandCenter) {
            const lastBeforeSetup = result.findIndex((item) => item.id === APP_IDS.SETUP) - 1;
            if (lastBeforeSetup >= 0) {
              result[lastBeforeSetup] = { ...result[lastBeforeSetup], cssClass: 'section-end' };
            }
          }

          setItems(result);
        })
        .catch((error) => {
          console.error('Failed to fetch application picker items:', error);
          // TODO: Verify this, when TIC integration is done!
          const apps = [
            APP_IDS.HOME,
            APP_IDS.CLOUD,
            APP_IDS.TMM,
            APP_IDS,
            APP_IDS.COMMAND_CENTER,
            APP_IDS.SETUP,
          ]
            .map((a) => applicationPickerItems.find((i) => i.id === a))
            .filter((a): a is ApplicationPickerItem => !!a);
          setItems(apps);
        });
  }, [userId, client]);

  return items;
};

export default useApplicationPickerItems;
